import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { AppStatic, ContentService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { Subject, takeUntil } from 'rxjs';

// animations inspired by: 
// https://www.youtube.com/watch?v=HSxQbGXDo3U&ab_channel=BrianTreese
// https://stackblitz.com/edit/stackblitz-starters-3ufzct?file=src%2Fsign-up-form%2Fsign-up-form.component.ts

@Component({
  selector: 'lcp-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  animations: [
    trigger('activeServiceChange', [
      transition('* => *', [
        query(':self', [
          style({height: '{{startHeight}}px'})
        ]),
        query(':enter', [
          style({opacity: 0, scale: 0.9})
        ], { optional: true }),
        query(':leave', [
          style({opacity: 1, scale: 1, height: '*'}),
          animate('1ms ease-in', style({opacity: 0, scale: 0.5, height: '{{startHeight}}px'}))
        ], { optional: true }),
        group([
          query(':self', [
            animate('500ms ease-in', style({height: '*'}))
          ]),
          query(':enter', [
            animate('500ms ease-in', style({opacity: 1, scale: 1}))
          ], { optional: true }),
        ], { params: { startHeight: 0 } })
      ])
    ])
  ]
})
export class AboutComponent implements OnInit, AfterViewInit, OnDestroy {


  @ViewChild('aboutServicesSection') aboutServicesSection: ElementRef


  slug = 'about'
  content: any
  fields: any

  // route$: any
  // fragment$: any
  fragment: string
  defaultService = 'marketing_outreach'

  aboutServicesImageSrc: string
  displayProcess = true //false
  aboutServices: any

  destroy$: Subject<boolean> = new Subject<boolean>();

  // activeService: string
  protected activeService = signal<string>(this.defaultService)

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public contentService: ContentService,
    public lcpHelper: LcpHelper
  ) { }

  ngOnInit(): void {
    // console.log('activeService', this.activeService())
    this.getPage()
    // this.route$ = 
    this.routeStream()
    // this.fragment$ = 
    this.fragmentStream()
  }

  ngAfterViewInit(): void {
    if(!this.fragment) return
    switch (this.fragment) {
      case this.defaultService: {
        setTimeout(() => {
          // console.log('services!', this.aboutServicesSection)
          // this.aboutServicesSection.nativeElement.scrollIntoView();
          try {
            document.getElementsByClassName('lcp-about-services')[0].scrollIntoView()
          } catch {
            console.log('ERR:lcp-about-services')
          }
        }, 500)
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();

    // if (this.fragment$) this.fragment$.unsubscribe()
    // if (this.route$) this.route$.unsubscribe()
  }


  setActiveService(service: string) {
    this.activeService.set(service);
  }

  initLinkHandler() {
    if (!AppStatic.isBrowser) return
    // console.log('ilh')
    let els = document.getElementsByClassName('lcp-embedded-link')
    var arr = Array.prototype.slice.call( els )
    // console.log('arr', els, arr)
    for (let [i, el] of arr.entries()) {
      let slug = el.dataset['slug']
      if (slug === 'how-we-practice') {
        el.addEventListener("click", () => {
          this.displayProcess = !this.displayProcess;
          this.displayProcess ? el.classList.add('is-active') : el.classList.remove('is-active')
        });
      }
    }
  }
  
  fragmentStream() {
    return this.route.fragment
    .pipe(takeUntil(this.destroy$))
    .subscribe(fragment => { 
      this.fragment = fragment // || 'print' 
    })
  }

  routeStream() {
    return this.router.events
    .pipe(takeUntil(this.destroy$))
    .subscribe((val) => {
      if (val instanceof NavigationEnd) {
        // console.log('navEnd', val)
        // this.updatePath()
        this.update()
      }
    })
  }

  update() {
    if (!AppStatic.isBrowser) return
    this.fragment = this.route.snapshot.fragment as string

    this.setActiveService(this.fragment || this.defaultService)
    // console.log('fragment', this.fragment)

    // update embedded link 'is-active'
    let els = document.getElementsByClassName('lcp-embedded-link')
    var arr = Array.prototype.slice.call( els )
    // console.log('arr', els, arr)
    for (let [i, el] of arr.entries()) {
      // console.log('el', el) // this.fragment, el.getAttribute('href'))
      if (!this.fragment && i == 0) {
        el.classList.add('is-active')
        continue
      } else if (window.location.href != el.getAttribute('href')) {
        el.classList.remove('is-active')
        continue
      }
      el.classList.add('is-active')
      // console.log('match!', el)
    }

    // update service image shown
    let imgs = document.getElementsByClassName('about-services-image-container')
    var imgarr = Array.prototype.slice.call( els )
    // console.log('img-arr', els, arr)
    for (let [i, el] of arr.entries()) {
      // console.log('el', this.fragment, el.getAttribute('href'))
      if (!this.fragment && i == 0) {
        el.classList.add('is-active')
        continue
      } else if (window.location.href != el.getAttribute('href')) {
        el.classList.remove('is-active')
        continue
      }
      el.classList.add('is-active')
      // console.log('match!', el)
    }
  }

  getPage(){
    // this.contentService.getPage({'fields.slug': 'home', 'fields.version': 2 })
    this.contentService.getPage({ 'fields.slug': this.slug })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (content) => {
        this.content = content
        if (!this.content) return console.log('!content', this.content)
        // console.log('ci0', this.slug, this.content.items, this.content.items[0]);
        this.fields = this.content.items[0].fields
        this.aboutServices = this.fields.sections[0].fields?.items?.filter(i => i.fields?.slug !== 'about-services-nav')
        this.updateActiveService()
        // console.log('fields, aboutServices', this.fields, this.aboutServices);
        setTimeout(() => {
          this.initLinkHandler()
          this.update()
        }, 500)
        // this.initLinkHandler()
        // this.update()
        // this.update()
      }
    });
  }

  updateActiveService() {
    let sections = this.fields['sections']
    let servicesSection = sections.find((section:any) => section.fields['slug'] == 'about-services')
    // console.log('UAS', servicesSection.fields['items'])
    // this.defaultService = this.fields['sections'].fields
  }

  isActiveAboutService(service: any) {
    // fragment == service
    // console.log('CHECK', this.activeService(), service.fields?.slug.split('about-services--')[1])
    return this.activeService() == service.fields?.slug.split('about-services--')[1]
  }
}
